import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bool, func, string, array } from 'prop-types';
import { ModalStyled, ModalActionsStyled, ButtonStyled, Typeahead, Box } from '@nike/nike-design-system-components';

import { addContractDepartmentAssociation } from '../actions';
import { getIsSubmittingContractDeptChange } from '../selectors';

import LoadingAnimation from '../../../components/LoadingAnimation';

const customSearchFn = (itemsToSearch, inputValue) => {
  return itemsToSearch.filter(item => item?.toLowerCase()?.indexOf(inputValue?.toLowerCase()) > -1);
};

const AddDepartmentModal = ({ isOpen, closeModal, departmentTypeaheadOptions, contractNumber, contractId }) => {
  const dispatch = useDispatch();

  const [departmentNumber, setDepartmentNumber] = useState(null);

  const handleDepartmentSelect = selectedDepartment => {
    const selectedDepartmentNumber = selectedDepartment.split(' ')[0];
    setDepartmentNumber(selectedDepartmentNumber);
  };

  const isSubmitting = useSelector(getIsSubmittingContractDeptChange);

  return (
    <ModalStyled
      isOpen={isOpen}
      closeModal={closeModal}
      title={`Associate a Department to Contract ${contractNumber}`}
      backdropCompProps={{ style: { backdropFilter: 'blur(4px)' } }}
      slots={{
        FooterSlot: (
          <ModalActionsStyled>
            <ButtonStyled
              type='submit'
              appearance='primary'
              onClick={() => dispatch(addContractDepartmentAssociation({ contractId, departmentNumber }))}
            >
              Submit
            </ButtonStyled>
            <ButtonStyled type='button' appearance='secondary' onClick={closeModal}>
              Cancel
            </ButtonStyled>
          </ModalActionsStyled>
        )
      }}
    >
      <Box height='300px'>
        <Typeahead
          id='addDepartmentToContract'
          label='Department'
          noResultsMessage='No matches found.'
          searchableItems={departmentTypeaheadOptions}
          onItemSelect={handleDepartmentSelect}
          searchFn={customSearchFn}
        />
      </Box>

      {isSubmitting && (
        <Box
          data-testId='submitting-overlay'
          width='100%'
          height='75%'
          style={{
            position: 'absolute',
            top: '20%',
            left: '0',
            background: 'rgba(255, 255, 255, 0.7)',
            zIndex: '3'
          }}
        >
          <LoadingAnimation size='s' />
        </Box>
      )}
    </ModalStyled>
  );
};

AddDepartmentModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  departmentTypeaheadOptions: array.isRequired,
  contractNumber: string.isRequired,
  contractId: string.isRequired
};

export default AddDepartmentModal;
